module.exports = __webpack_public_path__ + "static/img/pCT_last.3f956ee8.png";